module.exports = __webpack_public_path__ + "img/illustration.c03a8054.svg";